// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__cMaPZ","icon":"mimic___style_icon__9LOuc","sm":"mimic___style_sm__b48cl","md":"mimic___style_md__h7qQp"};